import { render, staticRenderFns } from "./copyrightManagement.vue?vue&type=template&id=6f6177c3&scoped=true&"
import script from "./copyrightManagement.vue?vue&type=script&lang=js&"
export * from "./copyrightManagement.vue?vue&type=script&lang=js&"
import style0 from "./copyrightManagement.vue?vue&type=style&index=0&id=6f6177c3&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f6177c3",
  null
  
)

export default component.exports